module.exports = __webpack_public_path__ + "img/logo-cotizacion.d859cf66.png";